const serviceOffer = [
  { name: 'Dates', path: 'dates' },
  { name: 'Services', path: 'services' },
  { name: 'Assurance', path: 'insurance' },
];

const childrens = [
  ...serviceOffer.map(elem => ({
    path: elem.path,
    component: elem.name,
    name: `serviceOffer${elem.name}`,
  })),
];


export default childrens;
